import { PondIntimationService } from './../../services/pond-intimation.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-pond-progress-intimation',
  templateUrl: './pond-progress-intimation.component.html',
  styleUrls: ['./pond-progress-intimation.component.scss'],
})
export class PondProgressIntimationComponent implements OnInit {
  @ViewChild('farmerPondIntimationTable', { static: true })
  public farmerPondIntimationTable: Table;

  value1: string = 'yes';
  stateOptions: any[];
  pondIntimationObject: any;
  firstIntimation: any;
  secondIntimation: any;
  thirdIntimation: any;
  public farmerId: any;
  public intimationAction: boolean = false;
  public farmerPondIntimationData: any = [];

  public loading: boolean = false;
  public subscriptions: any = [];

  constructor(
    private pondIntimationService: PondIntimationService,
    private messageService: MessageService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) {}

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerData = farmerConfData.get('farmerDetails');

    this.farmerId = farmerConfData.get('Farmer_Id_');
    // this.farmerMobileNo = farmerConfData.get('farmerPh');

    this.loadData(this.farmerId);
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  
  loadData(farmerId){
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let mobile = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    // this.loader.start();

    let reqBody = {
      farmerID: farmerId,
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loading = true;
    // let sub = this.pondIntimationService.getAppIdByFarmerId(reqBodyAfterEncypt).subscribe({
    let sub = this.pondIntimationService.getAppIdByFarmerId(farmerId).subscribe({
      next: (data) => {
        // this.loader.close();
        if (data.length) {
          // this.pondIntimationService.GetFarmerPondIntimation(data[0]?.AppID).subscribe({
          let api = this.pondIntimationService
            .GetFarmerPondIntimation(reqBodyAfterEncypt)
            .subscribe({
              next: (resData) => {
                // let data = JSON.parse(this.cryptoJsService.DecryptToken(resData.data));
                // this.activityRecordService.activityRecord(mobile, 'Pond/Water Tank Intimation', farmerId, new Date(), 'Success');

                this.farmerPondIntimationData = resData;
                this.loading = false;
              },
              error: (err) => {
                this.loading = false;
                // this.activityRecordService.activityRecord(mobile, 'Pond/Water Tank Intimation', farmerId, new Date(), err);

                this.messageService.add({
                  severity: 'error',
                  summary: 'Error Message',
                  detail: err,
                });
              },
            });

            this.subscriptions.push(api);
        }else{
          this.loading = false;
        }
      },
      error: (err) => {
        // this.loader.close();
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      },
    });

    this.subscriptions.push(sub);
  }

  onIntimate(row) {
    this.intimationAction = true;
    // console.log('rowValue', row);

    this.pondIntimationObject = row;
    this.firstIntimation =
      this.pondIntimationObject.FirstIntimation?.toString();
    this.secondIntimation =
      this.pondIntimationObject.SecondIntimation?.toString();
    this.thirdIntimation =
      this.pondIntimationObject.ThirdIntimation?.toString();
    
    this.stateOptions = [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ];
  }

  onFormSubmit() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let mobile = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    let body = {
      appID: this.pondIntimationObject.AppID,
      firstIntimation: this.firstIntimation === 'true',
      secondIntimation: this.secondIntimation === 'true',
    };
    this.loader.start();
    this.pondIntimationService.updateFarmerPondIntimation(body).subscribe({
      next: (data: any) => {
        this.loader.close();
        if(data == "S:Successfully Submitted" || "S:Successfully Updated"){
          this.intimationAction = false;
          this.loadData(this.farmerId);
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: data,
          });
        } else{
          this.messageService.add({
            severity: 'info',
            summary: 'Response Message',
            detail: data,
          });
        }
          
  
        this.activityRecordService.activityRecord(mobile, 'Update Pond/Water Tank Intimation', this.farmerId, new Date(), data, body);

      },
      error: (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
        this.activityRecordService.activityRecord(mobile, 'Update Pond/Water Tank Intimation', this.farmerId, new Date(), err, body);

      },
    });
    
    
  }

  onBack(){
    this.intimationAction = false;
    this.pondIntimationObject = {};
  }
}
